import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#6DA544\" d=\"M23.254 16.174c.482-1.3.746-2.706.746-4.173s-.264-2.874-.746-4.174L12 6.783.746 7.827A12 12 0 0 0 0 12c0 1.467.264 2.874.746 4.173L12 17.219z\"></path><path fill=\"#FFDA44\" d=\"M23.253 7.826C21.558 3.256 17.16 0 12 0 6.84 0 2.442 3.257.746 7.826z\"></path><path fill=\"#D80027\" d=\"M12 24c5.16 0 9.558-3.257 11.253-7.827H.746C2.442 20.743 6.84 24 12 24\"></path><path fill=\"#F0F0F0\" d=\"M20.227 10.153h-6.286l-1.943-5.979-1.942 5.979H3.77l5.085 3.695-1.942 5.978 5.085-3.652 5.086 3.653-1.942-5.98z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }